'use strict'

const validator = {
  cpf (cpf) {
    let numbers
    let digits
    let sum
    let i
    let result
    let equalDigits = 1

    cpf = cpf.replace(/[^\d]+/g, '')

    if (cpf.length < 11) return false

    for (i = 0; i < cpf.length - 1; i++) {
      if (cpf.charAt(i) !== cpf.charAt(i + 1)) {
        equalDigits = 0
        break
      }
    }

    if (!equalDigits) {
      numbers = cpf.substring(0, 9)
      digits = cpf.substring(9)
      sum = 0

      for (i = 10; i > 1; i--) {
        sum += numbers.charAt(10 - i) * i
      }

      result = sum % 11 < 2 ? 0 : 11 - sum % 11

      if (String(result) !== digits.charAt(0)) return false

      numbers = cpf.substring(0, 10)
      sum = 0

      for (i = 11; i > 1; i--) {
        sum += numbers.charAt(11 - i) * i
      }

      result = sum % 11 < 2 ? 0 : 11 - sum % 11

      if (String(result) !== digits.charAt(1)) return false
      return true
    }

    return false
  },

  cnpj (value) {
    if (!value) return false

    // Aceita receber o valor como string, número ou array com todos os dígitos
    const validTypes =
      typeof value === 'string' || Number.isInteger(value) || Array.isArray(value)

    // Elimina valor em formato inválido
    if (!validTypes) return false

    // Guarda um array com todos os dígitos do valor
    const numbers = value.toString().match(/\d/g).map(Number)

    // Valida a quantidade de dígitos
    if (numbers.length !== 14) return false

    // Elimina inválidos com todos os dígitos iguais
    const items = [...new Set(numbers)]
    if (items.length === 1) return false

    // Cálculo validador
    const calc = (x) => {
      const slice = numbers.slice(0, x)
      let factor = x - 7
      let sum = 0

      for (let i = x; i >= 1; i--) {
        const n = slice[x - i]
        sum += n * factor--
        if (factor < 2) factor = 9
      }

      const result = 11 - (sum % 11)

      return result > 9 ? 0 : result
    }

    // Separa os 2 últimos dígitos de verificadores
    const digits = numbers.slice(12)

    // Valida 1o. dígito verificador
    const digit0 = calc(12)
    if (digit0 !== digits[0]) return false

    // Valida 2o. dígito verificador
    const digit1 = calc(13)
    return digit1 === digits[1]
  }
}

export default validator
